export const PaymentsMetricsNoDataNotice = () => (
    <div className="vyne-payments-landing-no-metrics">
        <div className="vyne-payments-no-data-content">
            A/R data isn't available for the selected time frame. Please adjust your selection to a more recent date to
            view available data.
        </div>
    </div>
);
